import { createMuiTheme } from '@material-ui/core/styles'
import { heading } from '../../utils/utils'

const mainFont = 'Figtree'

const white = '#fff'
const black = '#000'
// Couleurs — charte « Données charte graphique » (Thermor)
const primaryMain = '#E62610'
const primaryLight = '#FDE8E5'
const primaryHover = '#C41E0D'
const secondaryMain = black
const textColor = '#2C2E34'
const greyLight = '#D8DBE3'
const greyText = '#6B6D75'
const footerLinkColor = '#676c78'
const grey = '#8D929F'

const f12 = `12px`
const f14 = `14px`
const f15 = `15px`
const f16 = `16px`
const f18 = `18px`
const f21 = `21px`
const f22 = `22px`
const f26 = `26px`
const f30 = `30px`
const f32 = `32px`
const f36 = `36px`
const f45 = `45px`
const f56 = `56px`

const body = {
  fontSize: f16,
  lineHeight: 1.56,
}
const body2 = {
  fontSize: f15,
  lineHeight: 1.33,
}

const primaryButtonIntent = {
  backgroundColor: `${primaryMain} !important`,
  border: 'none !important',
  color: `${white} !important`,
  boxShadow: 'none !important',
  '& .MuiSvgIcon-root': {
    color: 'inherit',
  },
  '&:hover, &:focus, &:active, &.selected': {
    backgroundColor: `${primaryHover} !important`,
    boxShadow: 'none !important',
  },
  '&.Mui-disabled': {
    backgroundColor: `${greyLight} !important`,
    borderColor: `${greyLight} !important`,
    color: `${white} !important`,
  },
}

const secondaryButtonIntent = {
  backgroundColor: 'transparent !important',
  border: `1px solid ${textColor} !important`,
  color: `${textColor} !important`,
  boxShadow: 'none !important',
  '& .MuiSvgIcon-root': {
    color: 'inherit',
  },
  '&:hover, &:focus, &:active, &.selected': {
    backgroundColor: `${secondaryMain} !important`,
    borderColor: `${secondaryMain} !important`,
    color: `${white} !important`,
    boxShadow: 'none !important',
  },
  '&.Mui-disabled': {
    backgroundColor: 'transparent !important',
    borderColor: `${grey} !important`,
    color: `${grey} !important`,
  },
}

const tertiaryButtonIntent = {
  backgroundColor: 'transparent !important',
  border: 'none !important',
  color: `${textColor} !important`,
  boxShadow: 'none !important',
  paddingLeft: '8px !important',
  paddingRight: '8px !important',
  '& .MuiSvgIcon-root': {
    color: 'inherit',
  },
  '&:hover, &:focus, &:active, &.selected': {
    backgroundColor: 'transparent !important',
    color: `${primaryMain} !important`,
    boxShadow: 'none !important',
  },
  '&.Mui-disabled': {
    color: `${grey} !important`,
  },
}

const tertiaryButtonIntentOnDark = {
  ...tertiaryButtonIntent,
  color: `${white} !important`,
  '&:hover, &:focus, &:active, &.selected': {
    backgroundColor: 'transparent !important',
    color: `${primaryMain} !important`,
    boxShadow: 'none !important',
  },
}

const inputFieldStyles = {
  fontSize: `${f14} !important`,
  lineHeight: '1.43 !important',
  color: `${textColor} !important`,
  backgroundColor: `${white} !important`,
  borderRadius: '4px !important',
  border: `1px solid ${greyLight} !important`,
  '&::placeholder': {
    color: `${greyText} !important`,
    opacity: '1 !important',
  },
  '&:hover': {
    borderColor: `${grey} !important`,
  },
  '&:focus, &:focus-within': {
    borderColor: `${primaryMain} !important`,
    outline: 'none !important',
  },
}

const tertiarySelectIntent = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'transparent !important',
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none !important',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none !important',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none !important',
    },
  },
  '& .MuiSelect-select, & .MuiSelect-icon, & .MuiInputBase-input': {
    color: `${textColor} !important`,
  },
  '& .MuiSelect-select:focus': {
    backgroundColor: 'transparent !important',
  },
}

const breakpoints = {
  xs: 0,
  sm: 480,
  md: 768,
  lg: 1024,
  l: 1200,
  xl: 1440,
}

const theme = createMuiTheme({
  themeFont: {
    main: 'Figtree',
  },
  breakpoints: {
    values: breakpoints,
  },
  typography: {
    fontFamily: `${mainFont}, sans-serif`,
    h1: {
      lineHeight: 1.17,
      ...heading(f36, f56, 700, 700, mainFont, mainFont, false),
    },
    h2: {
      lineHeight: 1.25,
      ...heading(f32, f45, 700, 700, mainFont, mainFont, false),
    },
    h3: {
      lineHeight: 1.23,
      ...heading(f26, f30, 700, 700, mainFont, mainFont, false),
    },
    h4: {
      lineHeight: 1.23,
      ...heading(f22, f21, 700, 700, mainFont, mainFont, false),
    },
    h5: {
      lineHeight: 1.375,
      ...heading(f16, f18, 700, 700, mainFont, mainFont, false),
    },
    h6: {
      lineHeight: 1.33,
      ...heading(f15, f16, 700, 700, mainFont, mainFont, false),
    },
    body1: {
      ...body,
    },
    body2: {
      ...body2,
    },
    caption: {
      fontSize: f12,
      lineHeight: 1.17,
      fontWeight: 400,
    },
    button: {
      fontSize: f14,
      lineHeight: 1.67,
      textTransform: 'inherit',
    },
  },
  palette: {
    common: {
      black: textColor,
      white: white,
    },
    background: {
      default: white,
      paper: white,
    },
    primary: {
      main: primaryMain,
    },
    secondary: {
      main: secondaryMain,
    },
    success: {
      main: '#66792A',
    },
    error: {
      main: '#C11900',
    },
    warning: {
      main: '#9E6615',
    },
    divider: greyLight,
    primaryTransparent: {
      main: primaryMain,
      light: primaryLight,
    },
    secondaryTransparent: {
      main: secondaryMain,
      light: greyLight,
    },
    ternary: {
      main: primaryMain,
      light: primaryLight,
    },
    accent: {
      main: primaryMain,
    },
  },
  sizes: {
    headerHeight: 60,
    headerHeightTransparent: 90,
    logoWidth: 110,
    logoHeight: 30,
    footerBG: 168,
    basketWidth: 340,
    basketWidthLG: 440,
  },
  extraColors: {
    grey: '#D8DBE3',
    greyLight: '#EDEEF2',
    greyMedium: '#B8BBC5',
    greyText: '#6B6D75',
  },
  shadows: [
    'none',
    '0px 0px 15px rgba(46, 46, 46, 0.1)',
    '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
    '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
    '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
    '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
    '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
    '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)',
    '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
    '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
    '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
    '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
    '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
    '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
    '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
    '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
    '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
    '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
    '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
  ],
  spacing: 8,
  shape: {
    borderRadius: 4,
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '.header': {
          '&__col': {
            width: 'auto !important',
          },
          '&__right': {
            [`@media (min-width: ${breakpoints.lg}px)`]: {
              justifyContent: 'space-between !important',
              width: '70% !important',
            },
            [`@media (min-width: ${breakpoints.l}px)`]: {
              width: '80% !important',
            },
          },
        },
        '.menu__submenu': {
          zIndex: 2,
          fontSize: 15,
          '& ul': {
            paddingLeft: 20,
            '& li:hover': {
              textDecoration: 'none',
            },
          },
        },
        '.product__area .MuiBreadcrumbs-separator': {
          color: 'transparent',
          position: 'relative',
          fontSize: '1em',
          alignItems: 'end',
          top: 0,
          '&::before': {
            content: '"/"',
            color: textColor,
            position: 'absolute',
            left: 0,
          },
        },
        '.product__area .MuiBreadcrumbs-li': {
          color: textColor,
          '& a': {
            color: 'inherit',
          },
        },
        '.product__area .MuiBreadcrumbs-li:last-child': {
          color: grey,
          '& a': {
            color: 'inherit',
          },
        },
        '.search__button__icon': {
          marginLeft: '10px',
          width: '76%',
          '&.MuiButton-outlined': {
            color: `${black} !important`,
            borderColor: `${black} !important`,
            '&:hover, &:focus, &:active, &.selected': {
              color: `${white} !important`,
              borderColor: `${white} !important`,
            },
          },
        },
        '.footer': {
          '&__top, &__top__title': {
            backgroundColor: `${textColor} !important`,
            color: `${white} !important`,
          },
          '&__bottom': {
            backgroundColor: `${white} !important`,
            paddingTop: '0 !important',
          },
          '&__bottomRow1': {
            position: 'relative',
            color: `${white} !important`,
            paddingTop: 54,
            paddingBottom: 35,
            marginTop: 0,
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              bottom: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100vw',
              backgroundColor: textColor,
              zIndex: -1,
            },
            '& .MuiTypography-root, & .footer__baseline': {
              color: `${white} !important`,
            },
          },
          '&__bottomRow2': {
            backgroundColor: `${white} !important`,
            paddingTop: 24,
            paddingBottom: 48,
          },
          '&__menu': {
            '& a': {
              color: `${footerLinkColor} !important`,
              fontSize: 14,
              [`@media (min-width: ${breakpoints.lg}px)`]: {
                fontSize: 14,
              },
            },
            '& a:hover, & a:focus, & a:active, & a.selected': {
              color: `${black} !important`,
            },
          },
        },
        '.faq': {
          '&__btn': {
            color: `${primaryMain} !important`,
          },
        },
        '.productCard': {
          '&__title': {
            fontWeight: '700 !important',
            fontSize: '18px !important',
          },
          '&__price': {
            fontSize: '18px !important',
            color: `${secondaryMain} !important`,
            '&--ttc': {
              fontWeight: '700 !important',
              fontSize: '18px !important',
            },
            '&--original': {
              fontSize: '14px !important',
              fontWeight: '500 !important',
            },
          },
        },
        '.header__icons': {
          '& .header__cta--faq': {
            order: 1,
          },
          '& .header__cta--account': {
            order: 2,
          },
        },
        '.header__cta--account': {
          '& .MuiButton-label': {
            fontSize: 0,
          },
        },
        '.header__cta--faq': {
          '& .MuiButton-label svg': {
            display: 'none',
          },
          '& .MuiButton-label': {
            color: `${black} !important`,
          },
        },
        '.page--home': {
          '& .hero__home-box .ctas > a:first-child .MuiButton-root, & .ctas > a:first-child .MuiButton-root':
            {
              ...primaryButtonIntent,
            },
          '& .hero__home-box .ctas > a:first-child .MuiButton-outlined, & .ctas > a:first-child .MuiButton-outlined':
            {
              ...primaryButtonIntent,
            },
          '& .ctas > a:not(:first-child) .MuiButton-root': {
            ...secondaryButtonIntent,
          },
          '& .section-heros__cta': {
            ...primaryButtonIntent,
          },
          '& .section-savings__cta, & .section-univers__cta': {
            ...primaryButtonIntent,
          },
          '& .section-hiw__cta, & .section-faq__cta': {
            ...secondaryButtonIntent,
          },
          '& .section-faq__cta': {
            height: '58px !important',
          },
          '& .section-infos__cta, & .instaWall__instaButton': {
            ...secondaryButtonIntent,
          },
        },
        '.page--product': {
          '& .product__right': {
            paddingLeft: '0 !important',
            paddingRight: '0 !important',
          },
          '& .product__head': {
            flexDirection: 'column !important',
            alignItems: 'flex-start !important',
            margin: '0 !important',
            width: '100% !important',
            '& > .MuiGrid-item': {
              maxWidth: '100% !important',
              flexBasis: '100% !important',
              flexGrow: '0 !important',
              padding: '0 !important',
              margin: '0 !important',
            },
            '& .MuiGrid-container': {
              margin: '0 !important',
              width: '100% !important',
              '& > .MuiGrid-item': {
                padding: '0 !important',
                maxWidth: '100% !important',
                flexBasis: '100% !important',
              },
            },
          },
          '& .product__title, & .product__price, & .product__desc': {
            textAlign: 'left',
            width: '100%',
            paddingLeft: '0 !important',
            marginLeft: '0 !important',
          },
          '& .product__price': {
            padding: '0 !important',
            '& .product__prices': {
              padding: '0 !important',
              margin: '0 !important',
              justifyContent: 'flex-start',
            },
          },
          '& .product__details': {
            paddingLeft: '0 !important',
            marginLeft: '0 !important',
            width: '100%',
          },
          '& .product__desc': {
            '& > div, & p, & ul, & ol, & li': {
              paddingLeft: '0 !important',
              marginLeft: '0 !important',
            },
          },
          '& .product__btn-addtocart, & .sizes-add__btn': {
            ...primaryButtonIntent,
          },
          '& .product__reserve-btn': {
            ...secondaryButtonIntent,
          },
        },
        '.contact-page, .information, .checkout, .account': {
          '& .label, & .MuiFormLabel-root': {
            fontSize: `${f14} !important`,
          },
        },
        '.contact-page__submit, .shipping__next-button': {
          ...primaryButtonIntent,
        },
        '.account': {
          '& .MuiButton-containedSecondary': {
            ...secondaryButtonIntent,
          },
        },
        '.shop-pagination__next, .filters-drawer__apply': {
          ...tertiaryButtonIntent,
        },
        '.footer__contact-btn, .footer__faq-btn': {
          ...tertiaryButtonIntentOnDark,
        },
        '.carrier-accordion__address': {
          ...tertiaryButtonIntent,
          display: 'inline-block',
          width: 'fit-content',
          cursor: 'pointer',
          fontWeight: 400,
          padding: '0 !important',
          marginLeft: '0 !important',
          textDecoration: 'none !important',
        },
        '.input, .geosuggest__input': {
          ...inputFieldStyles,
        },
        '.invoice--download__button, .basket__continue-shopping': {
          ...tertiaryButtonIntent,
        },
        '.shop-menu__sort': {
          ...tertiarySelectIntent,
        },
        '.product-dynamic-tag': {
          display: 'inline-flex',
          alignItems: 'center',
          marginTop: 8,
        },
        '.product-dynamic-tag__chip': {
          height: 28,
          borderRadius: '9999px !important',
          backgroundColor: '#F8EFD8 !important',
          color: '#C99B2A !important',
          fontWeight: 600,
          fontSize: 14,
          lineHeight: '20px',
          border: '1px solid #F1E3BE',
        },
        '.product-dynamic-tag__chip .MuiChip-label': {
          paddingLeft: 10,
          paddingRight: 12,
        },
        '.product-dynamic-tag__chip .MuiChip-avatar': {
          width: 16,
          height: 16,
          marginLeft: 10,
          marginRight: -2,
          backgroundColor: 'transparent',
        },
        '.product-dynamic-tag__avatar': {
          width: '16px !important',
          height: '16px !important',
        },
        '.product-dynamic-tag__chip .MuiChip-avatar img': {
          filter:
            'brightness(0) saturate(100%) invert(70%) sepia(45%) saturate(798%) hue-rotate(357deg) brightness(92%) contrast(88%)',
        },
        '.product-dynamic-alert': {
          marginTop: 24,
        },
        '.product-dynamic-alert__content': {
          borderRadius: 10,
          border: '1px solid #E8D8B3',
          backgroundColor: '#F7F0E1',
          color: '#5F5850',
          alignItems: 'flex-start',
          boxShadow: 'none',
          padding: 16,
        },
        '.product-dynamic-alert__content.MuiAlert-standardSuccess, .product-dynamic-alert__content.MuiAlert-standardInfo, .product-dynamic-alert__content.MuiAlert-standardWarning, .product-dynamic-alert__content.MuiAlert-standardError':
          {
            backgroundColor: '#F7F0E1',
            color: '#5F5850',
          },
        '.product-dynamic-alert__content .MuiAlert-icon': {
          color: '#C99B2A',
          marginRight: 12,
          padding: 0,
          opacity: 1,
          marginTop: 2,
        },
        '.product-dynamic-alert__content .MuiAvatar-root': {
          width: 18,
          height: 18,
          backgroundColor: 'transparent',
        },
        '.product-dynamic-alert__content .MuiAvatar-root img': {
          filter:
            'brightness(0) saturate(100%) invert(70%) sepia(45%) saturate(798%) hue-rotate(357deg) brightness(92%) contrast(88%)',
        },
        '.product-dynamic-alert__content .MuiAlert-message': {
          padding: 0,
          fontSize: 14,
          lineHeight: '22px',
          color: '#5F5850',
        },
        '.product-dynamic-alert__content .MuiAlert-message p': {
          margin: 0,
        },
        '.product-dynamic-alert__content .MuiAlert-message p + p': {
          marginTop: 4,
        },
        '.product-dynamic-alert__content .MuiAlert-message strong': {
          display: 'block',
          fontWeight: 700,
          fontSize: 16,
          lineHeight: '24px',
          color: '#2F2F2F',
          marginBottom: 4,
        },
      },
    },
    MuiButton: {
      root: {
        padding: '12px 32px',
        borderRadius: '1.6875rem',
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: 1.43,
        textTransform: 'none' as const,
        '&.home-hero-cta--primary': {
          ...primaryButtonIntent,
        },
      },
      sizeSmall: {
        padding: '8px 16px',
        fontSize: 14,
      },
      sizeLarge: {
        padding: '12px 32px',
      },
      contained: {
        boxShadow: 'none',
        backgroundColor: `${primaryMain} !important`,
        color: `${white} !important`,
        '&:hover, &:focus, &:active, &.selected': {
          backgroundColor: `${primaryHover} !important`,
          boxShadow: 'none',
        },
      },
      containedPrimary: {
        backgroundColor: `${primaryMain} !important`,
        color: `${white} !important`,
        '&:hover, &:focus, &:active, &.selected': {
          backgroundColor: `${primaryHover} !important`,
        },
      },
      containedSecondary: {
        backgroundColor: `${secondaryMain} !important`,
        color: `${white} !important`,
        border: `1px solid ${secondaryMain} !important`,
        '&:hover, &:focus, &:active, &.selected': {
          backgroundColor: '#1A1A1A !important',
          borderColor: '#1A1A1A !important',
        },
      },
      outlinedPrimary: {
        backgroundColor: 'transparent !important',
        color: `${textColor} !important`,
        borderColor: `${textColor} !important`,
        '&:hover, &:focus, &:active, &.selected': {
          backgroundColor: `${secondaryMain} !important`,
          borderColor: `${secondaryMain} !important`,
          color: `${white} !important`,
        },
      },
      textPrimary: {
        color: `${textColor} !important`,
        backgroundColor: 'transparent !important',
        '&:hover, &:focus, &:active, &.selected': {
          backgroundColor: 'rgba(44, 46, 52, 0.08) !important',
          color: `${textColor} !important`,
        },
      },
      text: {
        color: `${textColor} !important`,
        backgroundColor: 'transparent !important',
        '&:hover, &:focus, &:active, &.selected': {
          backgroundColor: 'rgba(44, 46, 52, 0.08) !important',
          color: `${textColor} !important`,
        },
      },
      outlined: {
        padding: '12px 32px',
        borderWidth: 1,
        borderColor: `${textColor} !important`,
        color: `${textColor} !important`,
        backgroundColor: 'transparent !important',
        '&:hover, &:focus, &:active, &.selected': {
          backgroundColor: `${secondaryMain} !important`,
          borderColor: `${secondaryMain} !important`,
          color: `${white} !important`,
        },
      },
      outlinedSizeLarge: {
        padding: '12px 32px',
      },
      outlinedSizeSmall: {
        padding: '8px 16px',
        fontSize: 14,
      },
    },
    MuiPaper: {
      root: {
        boxShadow: '0px 0px 15px rgba(46, 46, 46, 0.1)',
      },
      rounded: {
        borderRadius: 4,
      },
    },
    MuiSelect: {
      root: {
        color: textColor,
      },
      selectMenu: {
        '&:focus': {
          background: white,
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 4,
        backgroundColor: white,
        fontSize: 14,
        lineHeight: 1.43,
        color: textColor,
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: greyLight,
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: grey,
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: primaryMain,
          borderWidth: 1,
        },
      },
      input: {
        padding: '12px 16px',
        fontSize: 14,
        lineHeight: 1.43,
        '&::placeholder': {
          color: greyText,
          opacity: 1,
        },
      },
    },
    MuiInputLabel: {
      root: {
        fontSize: 14,
        color: textColor,
      },
    },
    MuiChip: {
      root: {
        borderRadius: 0,
        fontSize: 15,
        fontWeight: 700,
        color: black,
        backgroundColor: 'transparent',
        height: 25,
        padding: 0,
      },
      label: {
        padding: 0,
      },
      sizeSmall: {
        height: 22,
        fontSize: 12,
        fontWeight: 400,
      },
      labelSmall: {
        paddingLeft: 10,
        paddingRight: 10,
      },
      colorPrimary: {
        color: primaryMain,
        backgroundColor: 'transparent',
      },
      colorSecondary: {
        color: secondaryMain,
        backgroundColor: 'transparent',
      },
    },
  },
})

export default theme
